import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import Slide from 'vue3-slide-verify';

import 'animate.css';

import * as ELIcons from '@element-plus/icons-vue'
let app = createApp(App)

for (let iconName in ELIcons) {
  app.component(iconName, ELIcons[iconName])
}

app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(VueCookies)
app.use(Slide)
// router.beforeEach((to,from,next)=>{
//     let token=localStorage.getItem('token');
//     if(token||to.path==='/login'){
//         next();
//     }else{
//         next('/login');
//     }
// })

// app.config.globalProperties.$upproject=false;

app.provide('global', {
  baseUrl: process.env.VUE_APP_HOST,//'https://qz.pz3d.cn/',
  // baseUrl: 'http://192.168.0.23:8086/',
  name: process.env.VUE_APP_WS_HOST,//'qz.pz3d.cn',
  userInfo: null,
  ossBaseUrl: "https://r-static.pz3d.cn/"
})
app.provide('user_data', {
  info: {},
})

app.provide('upproject', false)

app.mount('#app')

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}
